var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperCws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 247 247",
    style: {
      enableBackground: "new 0 0 113.4 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style21"
  }, "\r\n        .st0{fill:#717070}\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.333 48c-4.143 0-7.833-3.357-7.833-7.5V0H41.333C37.19 0 33.5 3.357 33.5 7.5v231c0 4.133 3.51 7.737 7.644 7.75l165.167.75h.015c1.993 0 3.731-1.037 5.136-2.438 1.412-1.407 2.039-3.568 2.039-5.562V48h-42.168zm.5 133h-99c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h99c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5zm0-33h-99c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h99c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5zm0-33h-99c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h99c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5zm0-31h-99c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h99c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5zm38.934-51H178.5V2.383L210.767 33z",
    id: "path23"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      strokeWidth: 0.25516528
    },
    d: "M111.061 246.474c-69.869-.343-71.02-.356-72.36-.857-1.77-.662-3.192-1.903-4.134-3.603l-.758-1.368V5.384l.692-1.177c.8-1.36 2.053-2.53 3.59-3.35L39.168.28 101.23.215l62.062-.066.07 20.99.071 20.989.71 1.444c.816 1.663 2.287 3.096 3.98 3.88 1.172.541 1.318.545 23.187.614l22.008.07v96.145c0 109.024.252 97.814-2.255 100.319-.987.986-1.843 1.578-2.702 1.87-1.487.506 5.06.506-97.3.004zm63.544-65.92c3.038-1.137 4.925-4.155 4.715-7.544-.19-3.067-1.606-5.088-4.532-6.466l-1.403-.661h-50.906c-48.404 0-50.97.023-52.224.46-2.945 1.028-4.727 3.539-4.89 6.89-.09 1.823-.03 2.133.704 3.623.896 1.82 2.155 2.976 4.045 3.715 1.156.452 3.253.47 52.164.482 50.39.012 50.975.006 52.327-.5zm.382-33.141c1.657-.75 3.433-2.658 3.988-4.287.519-1.523.519-3.741 0-5.264-.555-1.629-2.33-3.538-3.988-4.287l-1.347-.608h-51.16c-49.57 0-51.2.015-52.413.482-1.53.59-3.014 1.894-3.93 3.451-.616 1.05-.687 1.42-.686 3.594 0 2 .097 2.603.552 3.445.991 1.834 3.106 3.494 5.06 3.973.422.103 23.673.17 51.672.148l50.905-.039zm-.665-32.668c3.966-1.489 6.059-6.057 4.575-9.987-.63-1.667-2.14-3.298-3.823-4.127l-1.179-.58-51.21-.066c-51.088-.066-51.213-.065-52.608.457-4.802 1.797-6.363 8.195-2.946 12.076 1.096 1.245 2.613 2.097 4.349 2.442.613.122 23.792.202 51.51.18 42.144-.036 50.548-.1 51.332-.395zm-.047-31.048c1.807-.537 4.058-2.727 4.679-4.552 1.314-3.866-.446-7.972-4.153-9.688l-1.161-.537H71.064l-1.459.716c-2.792 1.371-4.285 3.83-4.28 7.048.005 3.194 2.131 6.099 5.157 7.043.895.28 10.239.344 51.76.358 45.587.016 50.804-.023 52.033-.388z",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      strokeWidth: 0.25516528
    },
    d: "M178.616 17.701V2.588l2.105 2.062c1.158 1.133 7.846 7.49 14.863 14.126a5625.584 5625.584 0 0 1 13.775 13.051l1.017.987h-31.76Z",
    id: "path34"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperCws);
export default __webpack_public_path__ + "static/media/paperCWS.3f688fe9c36787a59b274cf3ce427e39.svg";
export { ForwardRef as ReactComponent };